var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "unsubscribe", novalidate: "", action: _vm.action },
      on: {
        submit: [
          function($event) {
            $event.preventDefault()
            _vm.handleSubmit($event)
          },
          _vm.$v.$touch
        ]
      }
    },
    [
      _c("div", { staticClass: "form-group flex" }, [
        _c("label", { attrs: { for: "unsubscribe-email" } }, [
          _vm._v(_vm._s(_vm.gettext("Email address")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            class: {
              error: _vm.$v.email.$error,
              valid: _vm.$v.email.$dirty && !_vm.$v.email.$invalid
            },
            attrs: {
              type: "email",
              name: "email",
              id: "unsubscribe-email",
              placeholder: _vm.gettext("example@email.com")
            },
            domProps: { value: _vm.email },
            on: {
              blur: _vm.$v.email.$touch,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.email.$dirty && (!_vm.$v.email.email || !_vm.$v.email.required)
            ? _c("span", { staticClass: "form-error" }, [
                _vm._v(
                  _vm._s(_vm.gettext("Please enter a valid email address."))
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "btn btn-3d", attrs: { type: "submit" } }, [
          _vm._v(_vm._s(_vm.pgettext("Submit form", "Send")))
        ])
      ]),
      _vm._v(" "),
      _vm.errors
        ? _c(
            "div",
            { staticClass: "form-messages" },
            _vm._l(_vm.errors, function(error) {
              return _c(
                "p",
                { key: error, staticClass: "callout form-message error" },
                [_vm._v("\n          " + _vm._s(error) + "\n      ")]
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.messages
        ? _c(
            "div",
            { staticClass: "form-messages" },
            _vm._l(_vm.messages, function(message) {
              return _c(
                "p",
                { key: message, staticClass: "callout form-message" },
                [_vm._v("\n          " + _vm._s(message) + "\n      ")]
              )
            })
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7139a646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7139a646","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/UnsubscribeForm.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7139a646","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/UnsubscribeForm.vue
// module chunks = 0